import React, { useEffect, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const resumePages = ['https://cdn.magicpatterns.com/uploads/kmERtDY8df3ucVmkSr87Vb/dfghjkl;.png', 'https://cdn.magicpatterns.com/uploads/dAXLdeq3yr1JkFfhwRL8ta/zdxfcghbjnm,..png'];
interface ResumeModalProps {
  open: boolean;
  onClose: () => void;
}
export function ResumeModal({
  open,
  onClose
}: ResumeModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-203">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[60] bg-navy-dark/90 backdrop-blur-sm flex flex-col" role="dialog" aria-modal="true" aria-label="Resume of Richard M Oblath" onClick={onClose} data-id="element-204">
          {/* Toolbar */}
          <div className="flex items-center justify-between px-6 md:px-12 py-5 border-b border-white/10 shrink-0" data-id="element-205">
            <span className="font-serif text-lg md:text-xl text-offwhite" data-id="element-206">
              Richard M Oblath — Curriculum Vitae
            </span>
            <button onClick={onClose} aria-label="Close resume" className="w-10 h-10 rounded-full border border-white/20 text-offwhite flex items-center justify-center hover:border-gold hover:text-gold transition-colors" data-id="element-207">
              <X size={20} data-id="element-208" />
            </button>
          </div>

          {/* Pages */}
          <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.35,
        delay: 0.05
      }} className="flex-1 overflow-auto px-4 md:px-8 py-8" onClick={e => e.stopPropagation()} data-id="element-209">
            <div className="max-w-6xl mx-auto space-y-8" data-id="element-210">
              {resumePages.map((src, idx) => <img key={idx} src={src} alt={`Richard M Oblath curriculum vitae, page ${idx + 1}`} loading="lazy" decoding="async" className="w-full h-auto shadow-2xl bg-white" data-id="element-211" />)}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}